let apiUrl,socketSer,staticUrl,domain;

if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'beta') {
  apiUrl = 'http://api.beta.shanghunbao.com/api/v2/';
  // socketSer = 'ws://api.beta.shanghunbao.com:2346';
  socketSer = 'ws://api.beta.shanghunbao.com:9501';
  domain = 'http://api.beta.shanghunbao.com/';
  staticUrl = 'http://static.shanghunbao.com/';
} else if (process.env.NODE_ENV == 'production') {
  apiUrl = 'https://api.shanghunbao.com/api/v2/';
  // socketSer = 'ws://api.shanghunbao.com:2346';
  socketSer = 'ws://api.shanghunbao.com:9501';
  staticUrl = 'http://static.shanghunbao.com/';
  domain = 'http://api.shanghunbao.com/';
}



const conf = {
  API_URL: apiUrl,
  SOCKET_SER: socketSer,
  STATIC_URL: staticUrl,
  IMG_URL:domain,
}

export default conf



//////////////////
// WEBPACK FOOTER
// ./config/conf.js
// module id = null
// module chunks = 